import { showDialog } from 'vant'
import type { DialogOptions } from 'vant'

export const $alert = (options: DialogOptions) => {
    const { message } = options
    return showDialog({
        message,
        title: '温馨提示',
        allowHtml: true,
        className: 'main-dialog main-dialog__alert',
        theme: 'round-button',
    })
}
